import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AppContext from '../../../context';
import Data from '../../../repository';
import Loading from '../../components/Loading';
import styles from '../../../styles/Services.module.scss';

function ServiceList() {
	const context = useContext(AppContext);
	const navigate = useNavigate();
	const [services, setServices] = useState([]);
	const [categories, setCategories] = useState([]);
	const [selectedCategory, setSelectedCategory] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		fetchData();
	}, []);

	const fetchData = async () => {
		try {
			const [servicesRes, categoriesRes] = await Promise.all([
				Data.fetchServices(),
				Data.fetchServiceCategories()
			]);
			setServices(servicesRes.data);
			setCategories(categoriesRes.data);
		} catch (error) {
			console.error('Error fetching services:', error);
		} finally {
			setLoading(false);
		}
	};

	const filteredServices = selectedCategory
		? services.filter(s => s.category === selectedCategory)
		: services;

	const formatPrice = (price) => {
		if (price === 0) return 'Free';
		return `£${(price / 100).toFixed(2)}`;
	};

	if (loading) return <Loading text="Loading services..." />;

	return (
		<div className={styles.services}>
			<div className={styles.header}>
				<h1>Our Services</h1>
				<p>Choose a service to book an appointment</p>
			</div>

			{categories.length > 0 && (
				<div className={styles.categories}>
					<button
						className={!selectedCategory ? styles.active : ''}
						onClick={() => setSelectedCategory(null)}
					>
						All
					</button>
					{categories.map(category => (
						<button
							key={category}
							className={selectedCategory === category ? styles.active : ''}
							onClick={() => setSelectedCategory(category)}
						>
							{category}
						</button>
					))}
				</div>
			)}

			<div className={styles.serviceGrid}>
				{filteredServices.map(service => (
					<div
						key={service._id}
						className={styles.serviceCard}
						onClick={() => navigate(`/dashboard/services/${service._id}`)}
					>
						<div className={styles.imageWrapper}>
							{service.image ? (
								<img src={service.image} alt={service.name} />
							) : (
								<div className={styles.placeholder}>
									{service.name.charAt(0)}
								</div>
							)}
						</div>
						<div className={styles.content}>
							<h3>{service.name}</h3>
							{service.description && (
								<p className={styles.description}>{service.description}</p>
							)}
							<div className={styles.meta}>
								<span className={styles.duration}>{service.duration} mins</span>
								<span className={styles.price}>{formatPrice(service.price)}</span>
							</div>
						</div>
					</div>
				))}
			</div>

			{filteredServices.length === 0 && (
				<div className={styles.emptyState}>
					<h3>No services available</h3>
					<p>Please check back later</p>
				</div>
			)}
		</div>
	);
}

export default ServiceList;
